import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_planApproval_projects = async (page, limit, keyword, groupBy) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/projects?page=${page}&limit=${limit}&keyword=${keyword}&groupBy=${groupBy}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_create_planApproval = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_create_planApproval_Revision = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/revision`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_planApproval_Status_Update = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/status`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_planApproval = async (page, limit, projectId, filterPayload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval?page=${page}&limit=${limit}&projectId=${projectId}&filterPayload=${filterPayload}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_planApproval_detail = async (planId, filterPayload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/${planId}?&filterPayload=${filterPayload}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_update_planApproval_assignee = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/assignee`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_add_planApproval_comment = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/comment`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_upload_plan_approval_document = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/document/file`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_plan_approval_logs = async (planId, page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval-logs?planId=${planId}&page=${page}&limit=${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_plan_approval_change_favourite_status = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/favouriteUnfavourite/plan`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v3_plan_approval_comment_change_favourite_status = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/favouriteUnfavourite/comment`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_plan_approval_comment_reply = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/comment/reply`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_plan_approval_comment_replies = async (planId, commentId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/comment/reply?planId=${planId}&commentId=${commentId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    });
};


export const v3_plan_approval_comment_status_update = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/comment/status`;
    return customAxios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    });
};


export const v3_plan_approval_send_report_mail = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/reportMail`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    });
};







